import loadable from '@loadable/component';
import AsyncLoader from 'Components/AsyncLoader/AsyncLoader';

export default loadable(() => import('./MobileNavigation'), {
  fallback: AsyncLoader(),
});
